import React from 'react';
import {Route, Redirect } from 'react-router-dom';
import Auth from './auth';
//import {Alert} from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';

export const ProtectedRoute = ({component: Component, ...rest})=>{
    ////console.log(Auth.isAuthenticated)
    return(
        <Route
            {...rest}
            render={ props => {
                if(Auth.isAuthenticated()){
                    return <Component {...props} />
                }else{
                    return <Redirect to={
                        {
                            pathname:"/"
                        }
                    }  />
                }
                
            }}
        
        />
    );
};


// WEBPACK FOOTER //
// ./src/middleware/protected.route.jsx